var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showing)?_c('div',[_c('div',[_c('modal-mask')],1),_c('div',{staticClass:"no-support"},[_c('div',{staticClass:"version-title"},[_vm._v("APP版本低")]),_vm._m(0),_c('div',{staticClass:"btn",on:{"click":_vm._close}},[_vm._v("关闭页面")])])]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"discript"},[_vm._v("请您升级到最新版本"),_c('br'),_vm._v("参与活动赢大奖")])
}]

export { render, staticRenderFns }